'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { Container } from '@/components/ui/container'
import { NavLinks } from './nav-links'
import { MobileMenu } from './mobile-menu'
import { cn } from '@/lib/cn'

export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false)
  // The home page has a full-bleed video hero that should run under the nav,
  // so at the top there we drop the bar's background entirely. Other pages
  // keep the frosted bar (their heroes — some dark — need readable links).
  const overHeroMedia = usePathname() === '/'

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={cn(
        'fixed inset-x-0 top-0 z-100 transition-[background,box-shadow] duration-300 ease-snappy',
        scrolled
          ? 'bg-paper/85 backdrop-blur-md backdrop-saturate-150 shadow-[0_1px_0_var(--color-line)]'
          : overHeroMedia
            ? 'bg-transparent' // hero video shows through at the top
            : 'bg-paper/55 backdrop-blur-md backdrop-saturate-150',
      )}
    >
      <Container as="nav" className="flex items-center justify-between py-4.5">
        <Link href="/" className="flex items-center gap-2.75 font-display text-[23px] font-extrabold tracking-[-0.03em]">
          <Image
            src="/logo.png"
            alt=""
            width={38}
            height={38}
            priority
            className="h-9.5 w-9.5 flex-none rounded-[11px] border-2 border-ink"
          />
          Ryens
        </Link>
        <NavLinks className="hidden md:flex" />
        <Link
          href="/contact"
          className="hidden rounded-[11px] border-2 border-ink bg-ink px-5 py-2.5 font-display text-[15px] font-semibold text-white md:inline-block"
        >
          Start your MVP
        </Link>
        <MobileMenu />
      </Container>
    </header>
  )
}
